import { useMsal } from "@azure/msal-react";
import { IContextualMenuItem, Spinner, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EValidationSeverity, IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import ValidationItem from "views/BlueRelationship/ValidationDialog/ValidationItem";

import { emitCustomEvent } from "global/Application";

interface IProps extends TComponentConnectedProps {
}


const DataValidationPanel: React.FunctionComponent<IProps> = (props) => {
    const [refresh, SetRefresh] = useState(0);

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [items, setItems] = useState<IValidationMessage[] | null>(null)

    const [loading, setLoading] = useState(false);

    const menu: IContextualMenuItem[] = [];
    menu.push({
        key: 'refresh',
        name: 'Refresh',
        icon: 'Refresh',
        onClick: (event, item) => {
            event?.preventDefault();
            event?.stopPropagation();
            SetRefresh(t => t + 1);
        },
    });

    useEffect(() => {
        (async () => {

            setLoading(true);

            try {
                
                const result = await dataSource.getGenerateSnapshotValidation(props.state.data.snapshot.bcbs_groupconfigurationsnapshotid!);

                if (result.length > 0) {
                    const items = result.map(e => {
                        const t: IValidationMessage = {
                            title: `${e.location}`,
                            type: EValidationSeverity.warn,
                            description: `${e.validator}\n${e.description}\n${e.path}`,
                        };

                        return t;
                    });

                    setItems(items);
                }
                debugger;

            } catch (error) {
                // lets create a new one is payload is not providing one
                // lets create a new one is payload is not providing one
                emitCustomEvent({
                    eventType: 'globalException',
                    details: error
                });

            } finally {
                setLoading(false);
            }


        })();

    }, [refresh]);

    return <CustomPanel title={"Backend Validation"}
        canCollapse={true}
        items={menu}
    >
        {loading &&
            <div>
                <Spinner label={"Loading"} styles={{ root: { margin: '25px' } }} />
            </div>
        }
        <Stack styles={{ root: { marginTop: '10px' } }}>
            {items && items.map(item => {
                return <ValidationItem
                    data={item}
                />
            })}

        </Stack>
    </CustomPanel>;
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(DataValidationPanel)

